import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Collapse, Divider, IconButton } from '@mui/material';
import { ArrowDropDownIcon, Stack, Typography } from '@esgian/esgianui';
import TargetDetailsInput from '@components/Inputs/BaselineInput/BaselineModal/TargetDetailsInput';
import { DISPLAY_UNIT } from '@constants/index';

const inputs = [
  { unit: DISPLAY_UNIT.ENERGY, inputUnit: 'MWh' },
  { unit: DISPLAY_UNIT.FUEL, inputUnit: 'mt' },
  { unit: DISPLAY_UNIT.CO2, inputUnit: 'mt' },
  { unit: DISPLAY_UNIT.NOX, inputUnit: 'kg' }
];

function TargetDetailsAnalyticsInput({
  title,
  baseline,
  fieldName,
  isLoading,
  handleInputChange,
  getHelperText,
  periodDetails,
  handleFocusOff = undefined
}) {
  const [expanded, setExpanded] = useState(false);
  return (
    <Box
      sx={{
        background: ({ palette }) => palette.neutral.neutral02,
        borderRadius: 0.5
      }}>
      <Box
        sx={{
          cursor: 'pointer',
          justifyContent: 'space-between',
          alignItems: 'center',
          display: 'flex',
          pl: 1
        }}
        onClick={() => setExpanded((prev) => !prev)}>
        <Typography bold variant={'body2'}>
          {title}
        </Typography>
        <IconButton aria-expanded={expanded} aria-label="show more">
          <ArrowDropDownIcon />
        </IconButton>
      </Box>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Divider />
        <Stack
          sx={{ pl: 5, pr: 2, pt: 1, pb: 1 }}
          spacing={periodDetails.startDate && periodDetails.endDate ? 0 : 2}>
          {inputs.map(({ inputUnit, unit }) => {
            let valueKey = `${fieldName}${unit}Waste`;
            return (
              <TargetDetailsInput
                key={valueKey}
                handleFocusOff={() => {
                  if (handleFocusOff) {
                    handleFocusOff(valueKey);
                  }
                }}
                loading={isLoading}
                unit={baseline.daily ? `${inputUnit}/day` : `${inputUnit}`}
                title={`${unit} savings potential`}
                value={baseline?.[valueKey] ?? null}
                onChange={(value) => handleInputChange(value, valueKey)}
                helperText={getHelperText(valueKey)}
              />
            );
          })}
        </Stack>
      </Collapse>
    </Box>
  );
}

TargetDetailsAnalyticsInput.propTypes = {
  title: PropTypes.string.isRequired,
  baseline: PropTypes.object,
  periodDetails: PropTypes.object,
  fieldName: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  handleInputChange: PropTypes.func.isRequired,
  getHelperText: PropTypes.func.isRequired,
  handleFocusOff: PropTypes.func
};

export default TargetDetailsAnalyticsInput;
